import { BaseEntity } from './base-entity';
import {ReorderDelayReason} from "./reorder-delay-reason";
import {NewsletterType} from "./newsletter-type";


export class Newsletter extends BaseEntity{
    public name: string;
    public isActive: boolean;
  public subject: string;
  public title: string;
  public bodyHtml: string;
  public mjml: string;
  public action: string;
  public actionLabel: string;
  public actionParameter: string;
  public sendDate: Date;
  public sendDateMm: number;
  public sendDateHh: number;

  public creationDate: Date;
  public isSent: boolean;
  public isSending: boolean;
  public filterCompanyId: number;
  public filterCompanyIds: string;
  public getFilterCompanyIdsAsList: number[];

  public filterNotInNewsletterIds: string;
  public getFilterNotInNewsletterIdsAsList: number[];

  public filterInNewsletterIds: string;
  public getFilterInNewsletterIdsAsList: number[];

  public filterCustomerId: number;
  public filterCustomerIds: string;
  public getFilterCustomerIdsAsList: number[];

  public filterProductId: number;
  public filterProductIds: string;
  public getFilterProductIdsAsList: number[];

  public filterNotProductIds: string;
  public getFilterNotProductIdsAsList: number[];

  public filterCardStatusId: number;
  public filterCardStatusIds: string;
  public getFilterCardStatusIdsAsList: number[];

  public filterCustomerIdentLevels: string;
  public getFilterCustomerIdentLevelsAsList: number[];

  //public filterWebIdStatusIds: number;
  //public getFilterWebIdStatusIdsAsList: number[];


  public filterOrderDateFrom: Date;
  public filterOrderDateTo: Date;

  public filterOrderCreateDateFrom: Date;
  public filterOrderCreateDateTo: Date;

  public filterCreateDateFrom: Date;
  public filterCreateDateTo: Date;

  public recipientsCount: number;

  public isPreparing: boolean;
  public isPrepared: boolean;
  public isRecipientsManually: boolean;

  public sentCount: number;
  public queuedCount: number;

  public filterAppDownload: boolean;
  public filterSepa: boolean;
  public filterSofort: boolean;
  public filterBtl: boolean;
  public filterAddressConfirmed: boolean;

  public filterReOrderPending: boolean|null;
  public filterReOrderDelayReason: ReorderDelayReason;

  public filterOrderLanguages: string;
  public filterOrderLanguagesAsList: string[];
  public filterPlatforms: string;
  public filterPlatformsAsList: number[];

  public type: NewsletterType;


}
